// Site navigation functionality

const SUBMENU_BTN = '.js--navigation--sublevel-toggle';

const navigation = {

  toggleSubMenu(btn) {
    const currentlyOpen = btn.getAttribute('aria-expanded') === 'true';

    if(currentlyOpen) {
      this.closeSubMenu(btn);
    } else {
      this.openSubMenu(btn);
    }
  },

  openSubMenu(btn) {
    // Close other open menus
    this.closeAllSubMenus();

    const navItem = btn.closest('.navigation__item');
    if(navItem) {
      navItem.classList.add('navigation__item--open');
    }
    btn.setAttribute('aria-expanded', 'true');
  },

  closeSubMenu(btn) {
    const navItem = btn.closest('.navigation__item');
    if(navItem) {
      navItem.classList.remove('navigation__item--open');
    }
    btn.setAttribute('aria-expanded', 'false');
  },

  closeAllSubMenus() {
    document.querySelectorAll(SUBMENU_BTN).forEach(btn => {
      this.closeSubMenu(btn);
    });
  },

  init() {

    document.addEventListener('click', event => {
      if(event.target.closest(SUBMENU_BTN)) {
        this.toggleSubMenu(event.target.closest(SUBMENU_BTN));
      } else if(!event.target.closest('.navigation__item')) {
        // Close submenus on outside click
        this.closeAllSubMenus();
      }
    });

    // Close submenus on Esc key
    document.addEventListener('keydown', event => {
      if(event.key === 'Escape' || event.key === 'Esc') {
        this.closeAllSubMenus();
      }
    });
  }
};

export default navigation;
